module.exports = __webpack_public_path__ + "static/media/churn.5116b6dd.png";